import { SKIPPED, getSyntheticsResultId, getSyntheticsTestId, willSyntheticsInjectRum, isSyntheticsTest } from '@datadog/browser-core';
export function startSyntheticsContext(hooks) {
  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref) {
    var eventType = _ref.eventType;

    if (!isSyntheticsTest()) {
      return SKIPPED;
    }

    var testId = getSyntheticsTestId();
    var resultId = getSyntheticsResultId();
    return {
      type: eventType,
      session: {
        type: "synthetics"
        /* SessionType.SYNTHETICS */

      },
      synthetics: {
        test_id: testId,
        result_id: resultId,
        injected: willSyntheticsInjectRum()
      }
    };
  });
}